import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Supplier Profiles</h2>
      <p>
        Supplier Profiles help centralise and manage all critical information related to vendors,
        service providers, and contractors in one secure location.
      </p>
      <p>This section allows you to manage:</p>
      <ul>
        <li>
          <strong>Profile identification:&nbsp;</strong>Create and label profiles clearly for
          businesses supplying services to your business.
        </li>
        <li>
          <strong>Contact and payment information:&nbsp;</strong>Record contact details, payment
          terms, and preferred payment methods (e.g. bank transfer, Stripe).
        </li>
        <li>
          <strong>Contract and compliance documentation:&nbsp;</strong>Store all supplier contracts
          and documentation.
        </li>
        <li>
          <strong>Performance history:&nbsp;</strong>Maintain notes on reliability, quality of
          service, responsiveness, supplier comments and other relevant history.
        </li>
        <li>
          <strong>Supplier management:&nbsp;</strong>Manage all of your suppliers and costs.
        </li>
        <li>
          <strong>Internal visibility:&nbsp;</strong>Ensure team members can easily locate and
          understand supplier arrangements to support efficient operations and communications.
        </li>
      </ul>
      <p>
        <strong>Tip:&nbsp;</strong>Keeping these supplier profiles up to date supports compliance,
        enhances vendor management, and improves internal records.
      </p>
    </div>
  );
};

export default Preview;
